module.exports = __webpack_public_path__ + "img/roundingPoint.3a6ccf3c.svg";